import { Injectable } from '@angular/core';
import { IDocumentDestinationService, IEntity } from 'interfaces-lib';
import { TemplateWorkflowConfig } from 'interfaces-lib';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InveniasDocumentDestinationService implements IDocumentDestinationService {
  getDocumentDestinations(
    entity: IEntity,
    template: TemplateWorkflowConfig,
    dialogResult?: IEntity[]
  ): Observable<IEntity[]> {
    // not implemented yet for Invenias
    return of([entity]);
  }
}
